import { useGetFiles, useGetFolders, useGetPins } from '@agently/api';
import { queryClient } from 'providers/QueryProvider';

const hasAuthToken = () => localStorage.getItem('authToken') !== null;

// Always refetch on route enter so persisted hub cache does not block fresh data.
const refreshHubData = () =>
  Promise.all([
    queryClient.fetchQuery({
      ...useGetFolders.getFetchOptions(),
      staleTime: 0,
    }),
    queryClient.fetchQuery({
      ...useGetFiles.getFetchOptions(),
      staleTime: 0,
    }),
    queryClient.fetchQuery({
      ...useGetPins.getFetchOptions(),
      staleTime: 0,
    }),
  ]);

export const hubLoader = async () => {
  if (!hasAuthToken()) return;

  await refreshHubData().catch(() => {
    // Keep route preloading best-effort so existing component boundaries handle
    // auth/API errors the same way they did before loaders were added.
  });
};

export const prefetchHubRoute = () =>
  Promise.all([
    queryClient.prefetchQuery(useGetFolders.getFetchOptions()),
    queryClient.prefetchQuery(useGetFiles.getFetchOptions()),
    queryClient.prefetchQuery(useGetPins.getFetchOptions()),
  ]);
